import { initModal, closeModal, handleModalTabbing } from '../../node_modules/glo-shared-js/utils/modal-helpers';

(function() {
	document.addEventListener('DOMContentLoaded', function() {
		// Init Modal
		var initModalElementClasses = [
			'.teacher__bio-image-container[hasbiovideo]',
			'.class-card--init-modal',
		].join(',');

		if (document.querySelectorAll(initModalElementClasses)) {
			document.querySelectorAll(initModalElementClasses).forEach(function(element) {
				element.addEventListener('click', initModal);
			});
		}

		// Close Modal
		var closeModalElementClasses = [
			'.modal__close-modal',
			'.modal__close-button',
		].join(',');

		if (document.querySelectorAll(closeModalElementClasses)) {
			document.querySelectorAll(closeModalElementClasses).forEach(function(element) {
				element.addEventListener('click', closeModal);
			});
		}

		if (document.querySelector('.modal[open]')) handleModalTabbing();
	});
})();
